module.exports = __webpack_public_path__ + "assets/img/icon-wechat-h5.4ad48a70.png";